import FileUploaded from './FileUploaded';

export default FileUploaded;
